import React from 'react'
import Logo from '../parts/Logo'

export default Header
function Header() {
  return (
    <header className={`brd-b-1 pad-v-1`}>
      <div className={`content-width row-cen-cen`}>
        <Logo />
      </div>
    </header>
  )
}
